import { useEffect } from "react";
import { Container, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

const Terms = () => {
  const windowHeight = window.innerHeight;

  useEffect(() => {
    const reveal = (className) => {
      var reveals = document.querySelectorAll(className);

      for (var i = 0; i < reveals.length; i++) {
        var elementTop = reveals[i].getBoundingClientRect().top;
        var elementVisible = 150;

        if (elementTop < windowHeight - elementVisible) {
          reveals[i].classList.add("active");
        } else {
          reveals[i].classList.remove("active");
        }
      }
    };

    window.addEventListener("scroll", () => {
      reveal(".reveal");
      reveal(".reveal2");
      reveal(".reveal3");
      reveal(".reveal4");
    });

    reveal(".reveal");
    reveal(".reveal2");
    reveal(".reveal3");
    reveal(".reveal4");

    return () => {
      window.removeEventListener("scroll", () => {
        reveal(".reveal");
        reveal(".reveal2");
        reveal(".reveal3");
        reveal(".reveal4");
      });
    };
  }, [windowHeight]);

  return (
    <>
      <Helmet>
        <title>Warunki korzystania | Anten-Sat</title>
        <meta
          name="description"
          content="Warunki korzystania z usług ANTEN-SAT. Zapoznaj się z zasadami korzystania z naszej strony."
        />
        <link rel="canonical" href="https://antensat.pl/terms" />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <Container fluid className="hero">
        <h1 className="reveal3 p-4">
          OGÓLNE WARUNKI UŻYTKOWANIA STRONY INTERNETOWEJ
        </h1>
        <hr className="custom-hr" />
        <Row className="p-4 reveal2">
          <h4>I. PREAMBUŁA</h4>
          <p>
            <ol>
              <li>
                Niniejszy dokument określa warunki dostępu i korzystania ze
                strony internetowe, zwany będzie dalej: "Ogólne warunki".
              </li>
              <li>
                Każdy Użytkownik z chwilą podjęcia czynności zmierzających do
                korzystania ze strony internetowej zobowiązany jest do
                zapoznania się, przestrzegania oraz akceptacji Ogólnych
                warunków, bez ograniczeń i zastrzeżeń.
              </li>
              <li>
                W przypadku niewyrażenia zgody na wszystkie Ogólne warunki
                należy zaprzestać korzystania ze strony internetowej i
                natychmiast ją opuścić.
              </li>
              <li>
                Wszystkie nazwy handlowe, nazwy firm i ich logo, użyte na
                stronie internetowej należą do ich właścicieli i są używane
                wyłącznie w celach identyfikacyjnych. Mogą być one zastrzeżone
                znakami towarowymi.
              </li>
              <li>
                Zabrania się nieuprawnionego korzystania z zawartości strony
                internetowej lub informacji, jak też in nieuprawnionej
                reprodukcji, retransmiji lub innego użycia jakiegokolwiek
                elementu strony internetowej, gdyż takie działanie może naruszać
                m.in prawa autoskie lub chronione znaki towarowe.
              </li>
              <li>
                Pytania lub uwagi dotyczące strony internetowej można zgłaszać
                na następujący adres e-mail: <b>antensat.kontakt@gmail.com</b>
              </li>
            </ol>
          </p>
        </Row>
        <hr className="custom-hr" />
        <Row className="p-4 reveal3">
          <h4>II. DEFINICJE</h4>
          <p>
            <ol>
              <li>
                <b>FORMULARZ KONTAKTOWY</b> - kwestionariusz dostępny na stronie
                internetowej, który umożliwia natychmiastowe wysłanie wiadomości
                do Właściciela strony internetowej.
              </li>
              <li>
                <b>PRAWO WŁAŚCIWE</b> - Do celów realizacji Ogólnych warunków
                zastosowanie ma prawo polskie.
              </li>
              <li>
                <b>STRONA INTERNETOWA </b> - Narzędzie, o nazwie{" "}
                <Link to="https://antensat.pl/">https://antensat.pl/</Link>{" "}
                służące do świadczenia usług elektronicznych.
              </li>
              <li>
                <b>UŻYTKOWNIK </b> - osoba fizyczna, osoba prawna, albo
                jednostka organizacyjna nieposiadająca osobowości prawnej,
                której ustawa przyznaje zdolność prawną, korzystająca z usług
                elektronicznych dostępnych w ramach strony internetowej.
              </li>
              <li>
                <b>WARUNKI </b> - zbiór wszystkich postanowień m.in. niniejszych
                Ogólnych warunków, zasad polityki prywatności, plików cookies
                oraz wszelkich innych warunków, znajdujących się na stronie
                internetowej, które dotyczą określonych funkcji, właściwości lub
                promocji, jak również obsługi klienta.
              </li>
              <li>
                {" "}
                <b>WŁAŚCICIEL </b>
                Podmiot udostępniający niniejszą stronę internetową, mianowicie
                Przedsiębiorca Pan Jarosław Golanowski, prowadzący działalność
                gospodarczą pod firmą: Anten-Sat, z siedzibą przy: ul. Stawowa
                5, 42-274, Konopiska, NIP: 5731348654.
              </li>
            </ol>
          </p>
        </Row>
        <hr className="custom-hr" />
        <Row className="p-4 reveal4">
          <h4>III. ZAKRES WARUNKÓW</h4>
          <p>
            <ol>
              <li>
                Właściciel zapewnia dostęp do zawartości strony internetowej,
                zgodnie z poniższymi Ogólnymi warunkami.
              </li>
              <li>
                Zawartość i dane publikowane na stronie internetowej mają
                charakter informacyjny dla osób zainteresowanych i mogą być
                wykorzystywane jedynie do celów informacyjnych.
              </li>
              <li>
                Użytkownicy mogą korzystać z dostępu i usług oferowanych na
                stronie internetowej, pod warunkiem uprzedniego wyrażenia zgody
                na Ogólne warunki.
              </li>
            </ol>
          </p>
        </Row>
        <hr className="custom-hr" />
        <Row className="p-4 reveal">
          <h4>IV. ZASADY KORZYSTANIA ZE STRONY INTERNETOWEJ</h4>
          <p>
            <ol>
              <li>
                Strona internetowa jest obsługiwana przez wszelkiego rodzaju
                przeglądarki internetowe. Nie wymaga się żadnych szczególnych
                właściwości urządzenia końcowego Użytkownika.
              </li>
              <li>
                Po zaakceptowaniu Warunków, Użytkownik ma prawo przeglądać,
                kopiować, drukować oraz rozpowszechniać, bez dokonywania zmian w
                treści, zawartość niniejszej strony internetowej, pod warunkiem,
                że:
                <ul>
                  <li>
                    treści będą wykorzystywane wyłącznie informacyjnie, w celach
                    niekomercyjnych;
                  </li>
                  <li>
                    każda wykonana kopia będzie zawierała informacje na temat
                    praw autorskich lub dane dotyczące autora treści.
                  </li>
                </ul>
              </li>
              <li>
                Zakazane jest używanie i kopiowanie oprogramowania, procesów i
                technologii, stanowiących część strony internetowej.
              </li>
              <li>
                Użytkownicy mogą korzystać ze strony internetowej jedynie w
                poszanowaniu przepisów ustawy prawo telekomunikacyjne, ustawy o
                świadczeniu usług drogą elektroniczną i odpowiednich przepisów
                prawa cywilnego.
              </li>
              <li>
                <b>Zabronione </b>jest korzystanie ze strony:
                <ul>
                  <li>
                    w sposób prowadzący do naruszenia obowiązujących przepisów
                    prawa;
                  </li>
                  <li>
                    w jakikolwiek sposób niezgodny z prawem lub nieuczciwy, albo
                    w sposób, zmierzający do osiągnięcia niezgodnego z prawem
                    lub nieuczciwego celu;
                  </li>
                  <li>
                    do celów związanych z wyrządzeniem szkody dzieciom lub prób
                    wyrządzenia im jakiejkolwiek szkody;
                  </li>
                  <li>do form zaliczanych do zbiórczej kategorii SPAM;</li>
                  <li>
                    do świadomego przekazywania jakichkolwiek danych, wysyłania
                    lub wgryuwania jakichkolwiek materiałów zawierających
                    wirusy, konie trojańskie, oprogramowanie szpiegujące
                    (spyware), oprogramowanie z reklamami (adware) lub inny
                    szkodliowy program lub zbliżone kody komputerowe
                    zaprogramowane, by niekorzystnie wpływać lub zagrażać na
                    funkcjonowanie jakiegokolwiek oprogramowania lub sprzętu
                    komputerowego albo niekorzystnie wpływać lub zagrażać
                    Użytkownikowi.
                  </li>
                </ul>
              </li>
            </ol>
          </p>
        </Row>
        <hr className="custom-hr" />
        <Row className="p-4 reveal2">
          <h4>V. COOKIES</h4>
          <p>
            <ol>
              <li>
                Strona internetowa używa plików cookies (ciasteczka) lub podobną
                technologię (dalej łącznie nazwane: "cookies") do zbierania
                informacji o dostępie Użytkownika do strony internetowej (np. za
                pomocą komputera lub smartfona) oraz jego preferencjach. Są one
                wykorzystywane m.in w celach statystycznych oraz w celu
                dostosowania strony internetowej do indywidualnych potrzeb
                Użytkownika.
              </li>
              <li>
                Pliki cookies to fragmenty informacji, które zawierają unikalny
                kod referencyjny, który strona internetowa przesyła na
                urządzenie Użytkownika, w celu przechowywania, a czasem
                śledzenia informacji dotyczących używanego urządzenia. Zwykle
                nie pozwalają one zidentyfikować osoby Użytkownika. Ich głównym
                zastosowaniem jest lepsze dopasowanie strony internetowej do
                Użytkownika.
              </li>
              <li>
                Niektore z plików cookies, występujące na stronie internetowej,
                są dostępne tylko przez czas trwania danej sesji internetowej i
                wygasają po zamknięciu przeglądarki. Inne pliki cookies służą do
                zapamiętywania Użytkownika, który po powrocie na stronę
                internetową, jest na niej rozpoznawany. Są one wówczas
                zachowywane przez dłuższczy czas.
              </li>
              <li>
                Wszystkie pliki cookies, używane przez niniejszą stronę
                internetową, są zgodne z obowiązującym prawem Unii Europejskiej.
              </li>
              <li>
                Wszystkie pliki cookies, występuące na stronie internetowej, są
                ustalane przez Właściciela
              </li>
              <li>
                Większość Użytkowników i niektórych przeglądarek mobilnych
                automatycznie akceptuje pliki cookies. Jeżeli ustawienia te
                pozostaną bez zmian, pliki cookies zostaną zapisane w pamięci
                urządzenia.
              </li>
              <li>
                Użytkownik może zmienić preferencje dotyczace akceptacji plików
                cookies lub zmienić przeglądarkę, aby móc otrzymać za każdym
                razem stosowne powiadomienie, gdy funkcja cookies jest
                ustawiona. Aby zmienić ustawienia akceptacji cookies, należy
                dostosować ustawienia w przeglądarce.
              </li>
              <li>
                Pliki cookies będą wykorzystywane do niezbędnego zarządania
                sesją, w tym:
                <ul>
                  <li>
                    Rozpoznawianiu Użytkownika, który już wcześniej odwiedził
                    stronę internetową co pozwala na identyfikację liczby
                    unikalnych użytkowników, którzy skorzystali z serwisu i
                    pozwala upewnić się co do wystarczającej pojemności serwisu
                    dla liczby nowych użytkowników;
                  </li>
                  <li>
                    Dostosowania elementów układu szaty graficznej lub
                    zawartości strony internetowej;
                  </li>
                  <li>
                    Zbierania informacji statystycznych o tym, jak Użytkownik
                    korzysta ze strony, w celu możliwości ulepszenia witry i
                    stwierdzenia, które zakresy strony internetowej są
                    najbardziej popularne dla Użytkowników.
                  </li>
                </ul>
              </li>
            </ol>
          </p>
        </Row>
        <hr className="custom-hr" />
        <Row className="p-4 reveal3">
          <h4>VI. PLUGIN FACEBOOKA</h4>
          <p>
            <ol>
              <li>
                Strona internetowa zawiera plugin (wtyczkę) do serwisu
                społecznościowego Facebook.
              </li>
              <li>Plugin Facebooka jest oznaczony logo Facebook.</li>
              <li>
                Jeżeli Użytkownik odwiedza stronę internetową będąc zalogowanym
                na swoim profilu na Facebooku, Facebook zarejestruje informację
                o wizycie. Nawet w sytuacji, gdy Użytkownik nie jest zalogowany
                na Facebooku, Facebook jest w stanie pozyskiwać informacje o
                adresie IP.
              </li>
              <li>
                Facebook nie przekazuje Włascicielowi informacji gromadzonych
                danych i sposobie ich wykorzystania. Cel i zakres danych
                gromadzonych przez Facebook nie są znane Właścicielowi. W celu
                uzyskania dodatkowych informacji, dotyczących prywatności na
                portallu Facebook, należy kontaktować się bezpośrednio z
                Facebookiem lub zapoznać z{" "}
                <Link to="https://www.facebook.com/policy.php">
                  polityką prywatności portalu Facebook.
                </Link>
              </li>
              <li>
                Jeżeli Użytkownik nie chce, aby Facebook mógł pozyskiwać
                informacje dotyczące przeglądania strony internetowej dobrze
                jest, aby Użytkownik wylogował się wcześniej ze swojego konta
                Facebook.
              </li>
            </ol>
          </p>
        </Row>
        <hr className="custom-hr" />
        <Row className="p-4 reveal4">
          <h4>VII. LINKI ZEWNĘTRZNE</h4>
          <p>
            <ol>
              <li>
                Odnośniki znajdujące się na niniejszej stronie, do innych stron
                internetowych, są podane wyłacznie w celu informacyjnym.
              </li>
              <li>
                Właściciel strony internetowej nie ponosi odpowiedzialnosci za
                treści znajdujące się na innych witrynach. ani za jakiekolwiek
                szkody wynikające z ich użytkownika.
              </li>
            </ol>
          </p>
        </Row>
        <hr className="custom-hr" />
        <Row className="p-4 reveal">
          <h4>VIII. FORMULARZ KONTAKTOWY</h4>
          <p>
            <ol>
              <li>
                Użytkownik może wpisać swoje dane kontaktowe, wypełniając
                specjalny formularz przewidziany do kontaktu z Właścicielem,
                treść wiadomości i akceptując ich wysyłkę do Właściciela.
              </li>
              <li>
                Pozostawienie danych kontaktowych oznacza, że Użytkownik wyraził
                zgodę na przetwarzanie przez Właściciela podanych w Formularzu
                Kontaktowym danych osobowych. Właściciel będzie mógł użyć
                podanych danych kontaktowych, w celu wysłania ofert lub
                nawiązania kontaktu z Użytkownikiem.
              </li>
            </ol>
          </p>
        </Row>
        <hr className="custom-hr" />
        <Row className="p-4 reveal2">
          <h4>IX. POSZANOWANIE WŁASNOŚCI INTELEKTUALNEJ</h4>
          <p>
            <ol>
              <li>
                Strona internetowa oraz jej treści mogą być chronione prawami
                autorskimi, prawami dotyczącymi znaków towarowych oraz innymi
                przepisami, związanymi z ochroną własności intelektualnej
              </li>
              <li>
                Znaki, loga i inne spersonalizowane emblamaty Właściciela,
                pojawiające się na stronie internetowej (zwane łącznie:{" "}
                <b>"Znakami"</b>), stanowią znaki towarowe Właściciela.
              </li>
              <li>
                Z wyjątkiem osobnych, indywidualnych, pisemnych upoważnień,
                Użytkownik nie może wykorzystywać przez siebie, należących do
                Właściciela, Znaków: osobno, ani w zestawieniu z innymi
                elementami słownymi lub graficznymi, szczególnie w informacjach
                prasowych, reklamach, materiałach promocyjnych, marketingowych,
                w mediach, w materiałach pisemnych lub ustnych, w formie
                elektronicznej, w formie wizulanej ani w żadnej innej formie.
              </li>
            </ol>
          </p>
        </Row>
        <hr className="custom-hr" />
        <Row className="p-4 reveal3">
          <h4>X. OCHRONA DANYCH UŻYTKOWNIKA</h4>
          <p>
            <ol>
              <li>
                Właściciel szanuje w pełni prywatność Użytkowników. Szczegółowe
                informacje na temat sposobu gromadzenia i przetwarzania danych
                osobowych Użytkownika lub innych informacji, jak również
                sytuacji, w których Właściciel może je ujawniać, znajdują się w
                zakładce
                <Link to="/policy">Polityka Prywatności.</Link>
              </li>
            </ol>
          </p>
        </Row>
        <hr className="custom-hr" />
        <Row className="p-4 reveal4">
          <h4>XI. OGRANICZENIE ODPOWIEDZIALNOŚCI</h4>
          <p>
            <ol>
              <li>
                Strona internetowa zaiwera informacje o charakterze ogólnyum.
                Nie ma na celu pośredniczyć w świadczeniu jakichkolwiek usług
                doradztwa profesjonalnego.
              </li>
              <li>
                Strona internetowa nie zapewnia żadnych gwarancji dotyczących
                jej treści, w szczególności gwarancji bezpieczeństwa,
                bezbłędności, braku wirusów lub złośliwych kodów, gwarancji
                dotyczących poprawnego działania czy jakości.
              </li>
              <li>
                Strona internetowa nie zawiera żadnej rękojmi, wyrażanej lub
                dorozumianej, w tym gwarancji przydatności handlowej lub
                przydatności do określonego celu, nienaruszenia praw autoskich,
                dostosowania, bezpieczeństwa i rzetelności informacji.
              </li>
              <li>
                Użytkownik korzysta ze strony internetowej na własne ryzyko i
                przyjmuje na siebie pełną odpowiedzialnośc za szkody związane
                lub wynikające z jej wykorzystania, zarówno bezpośrednie jak i
                pośrednie, uboczne, następcze, moralne, lub inne szkody z tytułu
                odpowiedzialności umownej, deliktowej, z tytułu zaniedbań, w tym
                m.in. za utratę danych lub usług.
              </li>
              <li>
                Strona internetowa nie ponosi żadnej odpowiedzialności za linki
                zamieszczone na stronie internetowej, szczególnie jesli prowadzą
                do witryn, zasobów lub narzędzi utrzymanych przez osoby trzecie.
              </li>
              <li>
                Właścicel nie ponosi odpoweidzialnosci, jeśli strona internetowa
                jest z jakichkolwiek przyczyn tymczasowo lub długookresowo
                niedostępna.
              </li>
              <li>
                Właściciel nie ponosi odpoweidzialności za informacje
                przekazywane na stronie internetowej, ani też nie może zapewnić
                całkowitego bezpieczeństwa komunikacji, prowadzonych za pomocą
                strony internetowej.
              </li>
              <li>
                Pomimo podejmowanie przez Właściciela największych starań, w
                kwestii zapewnienia dokładnośći i aktualności strony
                internetowej, mogą pojawić się niezamierzone przez Właściciela
                błędy, które Użytkownik, po ich wykryciu, proszony jest zgłaszać
                Właścicielowi.
              </li>
              <li>
                Wszystkie wskazane powyżej wyłączenia i ograniczenia
                odpoweidzialności obowiązują w najszerszym dopuszczalnym prawnie
                zakresie, obejmując każdy typ istniejącej odpoweidzialności
                m.in. odpowiedzialności kontaktowej, deliktowej i każdej innej
                przewidzianej w polskim lub zagranicznym porządku prawnym.
              </li>
            </ol>
          </p>
        </Row>
        <hr className="custom-hr" />
        <Row className="p-4 reveal">
          <h4>XII. STOSUNEK DO ZAWARTYCH UMÓW</h4>
          <p>
            Jeśli nie postanowiono inaczej, Ogólne warunki stanowią kompletną i
            wyczerpującą umowę pomiędzy Użytkownikiem i Właścicielem, dotyczącą
            korzystania ze strony internetowej, w zakresie teści w nich
            zawartych oraz zastępują wszelkie inne porozumienia, uzgodnienia i
            umowy dotyczące przedmiotu (treści) niniejszych Ogólnych warunków.
          </p>
        </Row>
        <hr className="custom-hr" />
        <Row className="p-4 reveal">
          <h4>XIII. ZMIANA WARUNKÓW STRONY INTERNETOWEJ</h4>
          <p>
            <ol>
              <li>
                Właściciel strony internetowej zastrzega sobie prawo do
                dokonywania modyfikacji niniejszych Ogólnych warunków, w
                dowolnym momencie ich obowiązywania, zamieszczając ich
                zaaktualizwoaną wersję na stronie internetowej, które zaczynają
                obowiązywać Użytkowników od momentu ich publikacji, chyba że
                inaczej wskazano w zmodyfikowanych Ogólnych warunkach.
              </li>
              <li>
                Użytkownik ma obowiązek zapoznania się z modyfikacjami Ogólnych
                Warunków, o czym Właściciel poinformuje go w komunikacie o
                zmianach Ogólnych warunków do zaakceptowania.
              </li>
              <li>
                Dalsze korzystanie ze strony internetowej jest równoznaczne z
                akceptacją zmodyfikowanych Warunków strony internetowej.
              </li>
            </ol>
          </p>
        </Row>
        <hr className="custom-hr" />
        <Row className="p-4 reveal2">
          <h4>XIV. ROZWIĄZYWANIE SPORÓW</h4>
          <p>
            <ol>
              <li>
                Wszelkie powstałe spory Strony postanawiają w pierwszej
                kolejności rozwiązać w trybie polubownego załatwienia sprawy,
                przed właściwym sądem polubownym (zapis na sąd polubowny).
              </li>
              <li>
                Jeśli polubowne załatwienie sprawy okaże się niemożliwe, spór
                wynikający z niniejszej umowy zostanie rozstrzygnięty przez sąd,
                w którego okręgu znajduje się siedziba Właściciela
              </li>
            </ol>
          </p>
        </Row>
        <hr className="custom-hr" />
        <Row className="p-4 reveal3">
          <h4>XV. PODSTAWA PRAWNA</h4>
          <p>
            W sprawach nieuregulowanych w niniejszych Ogólnych warunkach stosuje
            się odpowiednio następujące ustawy:
            <ul>
              <li>
                ustawę z dnia 16 lipca 2004 r. prawo telekomunikacyjne (tj.
                Dz.U. z 2022 r. poz. 1648, ze zm.);
              </li>
              <li>
                ustawę z dani 18 lipca 2002 r. o świadczeniu usług drogą
                elektroniczną (tj. Dz.U z 2020 r. poz. 344, ze zm.);
              </li>
              <li>
                ustawę z dnia 4 lutego 1994 r. o prawie autorskim i prawach
                pokrenych (tj. Dz.U. z 2022 r. poz. 2509, ze zm.);
              </li>
              <li>
                ustawę z dnia 23 kwietnia 1964 r. Kodeks Cywilny (tj. Dz.U. z
                2022 r. z poz. 1360, ze zm.);
              </li>
              <li>oraz inne właściwe przepisy prawa polskiego. </li>
            </ul>
          </p>
        </Row>
        <hr className="custom-hr" />
        <Row className="p-4 reveal4">
          <h4>
            DZIĘKUJEMY ZA ZAPOZNANIE SIĘ Z NASZYMI WARUNKAMI UŻYTKOWANIA STRONY
            INTERNETOWEJ. ŻYCZYMY MIŁEGO KORZYSTANIA Z SERWISU.
          </h4>
        </Row>
        <hr className="custom-hr" />
      </Container>
    </>
  );
};

export default Terms;
